module.exports = __webpack_public_path__ + "img/P150T_weapon_42.96466262.png";